import { render, staticRenderFns } from "./ErrorWindow.vue?vue&type=template&id=01642a51"
import script from "./ErrorWindow.vue?vue&type=script&lang=js"
export * from "./ErrorWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports